import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import useReactRouter from 'use-react-router';
import MaterialTable, { MTableToolbar } from 'material-table';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import useApi, { MyClubCApi } from '../../../api';
import useDataList from '../../../hooks/useDataList';
import useUser from '../../../auth/hooks';
import { formatRank } from '../../../utils/helpers';
import { useNavigator } from '../../../components/Navigator';
import router from '../../../api/router';
import useEditForm from '../../../hooks/useEditForm';
import { localization } from '../../../components/DataTable/utils';
import { extractDataError } from '../../../utils/errors';
import { useApolloClient } from '@apollo/react-hooks';
import useNotifier from '../../../components/Messages/hooks';
import Loading from '../../../components/Loading';
import { RANK_PRIORITY_MAP } from '../../../utils/enums';

const Statistics = () => {
  const navigate = useNavigator();
  const { match } = useReactRouter();
  const certificationsId = match.params.id;
  const api = useApi();
  const { user } = useUser();
  const pushMessage = useNotifier();
  const client = useApolloClient();
  const newApi = new MyClubCApi(client);

  const [iconLoad, setIconLoad] = React.useState(false);

  const generateProtocolXls = async (certificationID) => {
    setIconLoad(true);
    const res = await newApi.generateProtocolXls(certificationID);
    if (res.ok) {
      pushMessage({ text: t`Успішно сгенеровано` });
      setIconLoad(false);
      window.open(res.url, '_blank').focus();
    } else {
      const dataError = extractDataError(res.errors);
      pushMessage({ text: dataError });
      setIconLoad(false);
    }
  };

  const { data, loading } = useDataList({
    schema: api.schema.statistics,
    router: null,
    variables: { inputFilter: { certificationsId: Number(certificationsId) } },
  });
  const { dataCert } = useEditForm({
    schema: api.schema.certifications,
    router: null,
    variables: { inputFilter: { id: Number(certificationsId) } },
  });

  if (loading) return <Loading />;

  const countMap = data.reduce(
    (acc, curr) => {
      acc.countAthletes += curr.countAthletes;
      acc.countDealing += curr.countDealing;
      acc.countReDealing += curr.countReDealing;
      acc.countPassed += curr.countPassed;
      acc.countNotPass += curr.countNotPass;
      return acc;
    },
    {
      countAthletes: 0,
      countDealing: 0,
      countReDealing: 0,
      countPassed: 0,
      countNotPass: 0,
    }
  );

  const columns = [
    {
      title: t`Кю`,
      field: 'rank',
      render: ({ rank }) => formatRank(rank) || '',
      customSort: (a, b) =>
        (RANK_PRIORITY_MAP[a.rank] || 0) - (RANK_PRIORITY_MAP[b.rank] || 0),
    },

    { title: t`Заявлено (${countMap.countAthletes})`, field: 'countAthletes' },
    { title: t`Перших здач (${countMap.countDealing})`, field: 'countDealing' },
    {
      title: t`Перездач (${countMap.countReDealing})`,
      field: 'countReDealing',
    },
    { title: t`Здало (${countMap.countPassed})`, field: 'countPassed' },
    { title: t`Не здало (${countMap.countNotPass})`, field: 'countNotPass' },
  ];
  return (
    <Paper>
      <MaterialTable
        isLoading={loading}
        options={{
          search: true,
          pageSizeOptions: [20, 50, 100],
          actionsColumnIndex: -1,
          // filtering,
          // selection,
          // selectionProps,
          // showTextRowsSelected,
        }}
        localization={localization}
        title={
          <div>
            {t`Статистика екзамену`}
            <br />
            {t`Екзамен: ${dataCert ? dataCert.name : null}`}
          </div>
        }
        columns={columns}
        data={data || []}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <div style={{ padding: '0px 10px' }}>
                <Tooltip title='Повернутись до загального списку екзамену'>
                  <IconButton
                    aria-label='delete'
                    onClick={
                      user.isAdmin
                        ? () =>
                            navigate(
                              router.admin.certifications.athleteList(
                                certificationsId
                              )
                            )
                        : () =>
                            navigate(
                              router.cabinet.certifications.athleteList(
                                certificationsId
                              )
                            )
                    }
                  >
                    <KeyboardBackspaceIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
        }}
        actions={[
          {
            icon: iconLoad ? 'get_app' : 'description',
            tooltip: t`Завантажити протокол здач`,
            isFreeAction: true,
            onClick: () => generateProtocolXls(certificationsId),
          },
        ]}
      />
    </Paper>
  );
};

export default Statistics;
